var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import { Box, ListItem, ListItemIcon, Tooltip, Typography, useTheme, } from "@material-ui/core";
import clsx from "clsx";
import { ArrowRight } from "@material-ui/icons";
import { useLayoutConsumers } from "../../provider";
import useStyles from "./styles";
var NavItem = function (_a) {
    var _b, _c, _d;
    var title = _a.title, icon = _a.icon, path = _a.path, isCollapsable = _a.isCollapsable, isOpen = _a.isOpen, currentPath = _a.currentPath, onRouteChange = _a.onRouteChange, children = _a.children;
    var theme = useTheme();
    var _e = useLayoutConsumers(), open = _e.menu.open, menuToggle = _e.menuToggle;
    var classes = useStyles(theme);
    var handleClick = useCallback(function () {
        if (path) {
            if (!(children === null || children === void 0 ? void 0 : children.length)) {
                onRouteChange(path);
                menuToggle();
            }
        }
    }, [menuToggle, path, onRouteChange, children]);
    return (_jsx(Box, __assign({ className: classes.root }, { children: open ? (_jsxs(ListItem, __assign({ button: true, className: clsx(classes.listItem, (_b = {},
                _b[classes.activeUrl] = currentPath === path && !(children === null || children === void 0 ? void 0 : children.length),
                _b[classes.unActiveUrl] = currentPath !== path,
                _b)), onClick: handleClick }, { children: [_jsx(ListItemIcon, __assign({ className: classes.icon }, { children: icon })), _jsx(Typography, __assign({ variant: "subtitle2", component: "span", className: clsx(classes.text, (_c = {},
                        _c[classes.activeUrl] = currentPath.toLowerCase() === (path === null || path === void 0 ? void 0 : path.toLowerCase()) &&
                            !(children === null || children === void 0 ? void 0 : children.length),
                        _c)) }, { children: title })), isCollapsable && (_jsx(ListItemIcon, __assign({ className: classes.arrowIcon }, { children: !isOpen ? (_jsx(ArrowRight, { className: classes.collapsableIconArrow })) : (_jsx(ArrowRight, { className: clsx(classes.collapsableIconArrow, classes.collapsedIconArrow) })) })))] }))) : (_jsx(Tooltip, __assign({ title: title, placement: "right-start" }, { children: _jsx("div", __assign({ className: clsx(classes.listItem, (_d = {},
                    _d[classes.menuCloseActive] = currentPath === path,
                    _d[classes.menuCloseActiveunActiveUrl] = currentPath !== path,
                    _d)), onClick: handleClick }, { children: icon })) }))) })));
};
export default React.memo(NavItem);
